import { FileText } from 'lucide-react';

export interface DocumentCountButtonProps {
  /** How many files the row carries — nothing renders when this is 0. */
  count: number;
  onClick: () => void;
  size?: number;
}

/**
 * Row action that opens a list's attached documents, badged with how many
 * there are. Renders nothing when the row has no files, so callers can drop it
 * into a cell without a conditional of their own.
 */
export function DocumentCountButton({ count, onClick, size = 16 }: DocumentCountButtonProps) {
  if (count <= 0) return null;

  return (
    <button
      onClick={onClick}
      className="relative text-gray-400 hover:text-primary-600 transition-colors"
      title={`View ${count} document${count !== 1 ? 's' : ''}`}
      aria-label="View documents"
    >
      <FileText size={size} />
      <span className="absolute -top-1 -right-1 min-w-[14px] h-3.5 px-0.5 text-[9px] font-bold bg-primary-600 text-white rounded-full flex items-center justify-center">
        {count}
      </span>
    </button>
  );
}
